export default __webpack_public_path__ + "static/hallway_cover-5246321de2b5d677feb750349bd48624.png";